import { css } from '@/styled-system/css';

export const container = css({
  width: '100%',
  '& [data-testid="listing-card"]': {
    height: '100%',
  },
});
